import React, { useContext } from "react";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { AuthContextProvider, AuthContext } from "./AuthContext/Authcontext";
import MainRoute from "./MasterEntry/MainRoute/MainRoute";
// import GoogleTranslate from "./MasterEntry/Component/GoogleTranslate";

function AppContent() {
  const { user } = useContext(AuthContext); // Adjust this line based on your context

  return (
    <>
      <MainRoute />
    </>
  );
}

function App() {
  return (
    <AuthContextProvider>
      <AppContent />
    </AuthContextProvider>
  );
}

export default App;
